import unionBy from 'lodash/unionBy';
import transform from 'lodash/transform';
import cloneDeep from 'lodash/cloneDeep';
import { AzureFacet, ProviderFacetGroups } from 'store/providerSearch/types';
import { ProviderSearchInterface } from 'lib/hooks/ProviderSearch/useProviderSearch';
import { FiltersFormValues } from '../types';
import { defaultValues } from './FiltersContext';

const insuranceFacets = [
  ProviderFacetGroups.insuranceAliasValues,
  ProviderFacetGroups.insurancePlanNcid
];

//
//  Constant: filtersReqDTO
//  Description: Transforms options to shape of filters values
//
export const filtersReqDTO = {
  acceptsMyInsurance: ({ facets }: ProviderSearchInterface['options']) => {
    return Array.isArray(facets)
      ? facets.some(facet => insuranceFacets.includes(facet.group))
      : false;
  },
  filters: ({ filters }: ProviderSearchInterface['options']) => {
    return transform(
      unionBy(filters, Object.values(defaultValues.filters), 'group'),
      (res, filter) => {
        res[filter.group] = filter;
      },
      {} as FiltersFormValues['filters']
    );
  },
  facets: ({ facets }: ProviderSearchInterface['options']) => {
    return transform(
      facets || [],
      (res, facet) => {
        res[facet.group] = res[facet.group] ? [...res[facet.group], facet] : [facet];
      },
      cloneDeep(defaultValues.facets) as FiltersFormValues['facets']
    );
  }
};

//
//  Constant: filtersResDTO
//  Description: Transform filters values to shape of options
//
export const filtersResDTO = {
  filters: ({ filters }: FiltersFormValues) => Object.values(filters),
  facets: ({ facets, acceptsMyInsurance }: FiltersFormValues) => {
    if (!acceptsMyInsurance) {
      insuranceFacets.forEach(facet => {
        delete facets[facet];
      });
    }

    return transform<AzureFacet[], ProviderSearchInterface['options']['facets']>(
      facets,
      (res, values) => {
        values.forEach(value => {
          res?.push(value);
        });
      },
      []
    );
  }
};
